<template>
  <div class="reset-box flex-row-center">
        <Header1></Header1>

    <div class="reset">
      <div class="reset-header" v-if="!isSubmit">
        <div
          v-for="(item, index) in types"
          @click="type = item.type"
          :key="index"
          :class="type == item.type ? 'active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="reset-header" style="border: none" v-else></div>
      <div class="go-to-rigister" @click="goTo('/register')">
        还未注册，点击注册
      </div>
      <div class="reset-content">
        <!-- 找回第一步 -->
        <template v-if="!isSubmit">
          <!-- 短信找回 -->
          <el-form
            :model="messageForm"
            :rules="messageRules"
            ref="messageForm"
            label-width="0"
            class="demo-messageForm"
            v-if="type == 'phone'"
            key="messageRules"
          >
            <el-form-item prop="name">
              <el-input
                placeholder="请输入用户名"
                v-model="messageForm.name"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
<!-- 
            <el-form-item prop="cardId">
              <el-input
                placeholder="请输入身份证号"
                autocomplete="off"
                v-model="messageForm.cardId"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item> -->

            <el-form-item prop="phone" v-show="type == 'phone'">
              <el-input
                placeholder="请输入手机号"
                autocomplete="off"
                v-model="messageForm.phone"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" v-show="type == 'mail'">
              <el-input
                placeholder="请输入邮箱"
                autocomplete="off"
                v-model="messageForm.email"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <el-form-item style="margin-top: 100px">
              <el-button
                class="submit-btn"
                @click="submitForm('messageForm')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
          <!-- 邮箱找回 -->
          <el-form
            v-else
            :model="emailForm"
            :rules="emailRules"
            ref="emailForm"
            label-width="0"
            class="demo-emailForm"
            key="emailForm"
          >
            <el-form-item prop="name">
              <el-input
                placeholder="请输入用户名"
                v-model="emailForm.name"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
<!-- 
            <el-form-item prop="cardId">
              <el-input
                placeholder="请输入身份证号"
                autocomplete="off"
                v-model="emailForm.cardId"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item> -->

            <el-form-item prop="phone" v-show="type == 'phone'">
              <el-input
                placeholder="请输入手机号"
                autocomplete="off"
                v-model="emailForm.phone"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <el-form-item prop="email" v-show="type == 'mail'">
              <el-input
                placeholder="请输入邮箱"
                autocomplete="off"
                v-model="emailForm.email"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>

            <el-form-item style="margin-top: 100px">
              <el-button
                class="submit-btn"
                @click="submitForm('emailForm')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </template>
        <template v-else>
          <!-- 找回第二步骤 -->
          <el-form
            :model="updataForm"
            :rules="updataRules"
            ref="updataForm"
            label-width="0"
            class="demo-updataForm"
            key="updataForm"
          >
            <el-form-item prop="code">
              <el-input
                placeholder="请输入收到的验证码"
                autocomplete="off"
                v-model="updataForm.code"
                prefix-icon="el-icon-lock"
              >
                <el-button
                  slot="append"
                  @click="getCode(this.type)"
                  :disabled="disabled"
                  type="primary"
                  >{{ valiBtn }}</el-button
                >
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="设置6-18位登录密码"
                type="password"
                autocomplete="off"
                v-model="updataForm.password"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="repassword">
              <el-input
                placeholder="再次输入登陆密码"
                type="password"
                autocomplete="off"
                v-model="updataForm.repassword"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 100px">
              <el-button class="submit-btn" @click="submitForm('updataForm')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Header1 from "@/components/Header1.vue";
import { setnewpass, retrievepass,upretrievepass } from "@/api/resetPw.js";
import {
  checkPhone,
  checkCode,
  checkEmail,
  checkIdentitytionId,
} from "@/utils/reg";
export default {
  components: {
    Header1
  },
  data() {
    // 重复输入密码验证
    const repasswordValidator = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.updataForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      isSubmit: false, // 是否已提交验证
      types: [
        {
          name: "短信找回",
          type: "phone",
        },
        {
          name: "邮箱找回",
          type: "mail",
        },
      ],
      disabled: false,
      type: "phone",
      valiBtn: "获取验证码",
      messageForm: {
        name: "", // 用户名
        // cardId: "", // 密码
        phone: "", // 电话
      },
      emailForm: {
        name: "", // 用户名
        // cardId: "", // 密码
        email: "", // 邮箱
      },
      updataForm: {
        password: "",
        repassword: "",
        code: "", // 验证码
      },
      updataRules: {
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "长度在 6 到 18 个字符",
            trigger: "blur",
          },
        ],
        repassword: [{ validator: repasswordValidator, trigger: "blur" }],
        code: [{ validator: checkCode, trigger: "blur" }],
      },
      messageRules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        // cardId: [{ validator: checkIdentitytionId, trigger: "blur" }],
        phone: [{ validator: checkPhone, trigger: "blur" }],
      },
      emailRules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        // cardId: [{ validator: checkIdentitytionId, trigger: "blur" }],
        email: [{ validator: checkEmail, trigger: "blur" }],
      },
    };
  },
  methods: {
    goTo(item) {
      this.$router.push(item);
    },
    //获取验证码
    getCode(type) {
      // 根据 type 用来判断获取什么类型验证码
      

      
      this.tackBtn(); //验证码倒数60秒
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(9999, "通过");

          // 第一步找回
          if (!this.isSubmit) {
            // 电话找回
            if (this.type =='phone') {
              let params= {
                username: this[formName].name,
                phone: this[formName].phone,
              }
              retrievepass(params).then(res => {
                if (res.code == 200 ) {
                  this.isSubmit = !this.isSubmit;

                }
              })
            }else {
              
            }
            this.getCode(this.type);
          } else {
            //   第二步验证 验证码
            let data={
              upword: this.updataForm.password,
              code: this.updataForm.code,
            }
            upretrievepass(data).then(res =>{
              if (res.code == 200 ) {
                  this.$message.success('密码重置成功，为您跳转到登录页面！')
                  this.$router.push('/login')
                }
            })
          }
        } else {
          console.log(666, "不通过");

          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-box {
  width: 100%;
  height: 100%;
  .reset {
    position: relative;
    width: 600px;
    height: 680px;
    padding: 0 100px;
    padding-top: 100px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 100);
    color: rgba(58, 98, 215, 100);
    font-size: 14px;
    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
    font-family: Roboto;
    display: flex;
    flex-direction: column;
    .reset-header {
      height: 40px;
      margin: 0 50px;
      margin-bottom: 60px;
      color: #000;
      font-size: 20px;
      font-family: PingFangSC-regular;
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-bottom: 2px solid #eee;
      div {
        cursor: pointer;
      }
      .active {
        color: #ec1818;
      }
    }
    .reset-content {
      flex: 1;
    }
  }
  .go-to-rigister {
    position: absolute;
    top: 44px;
    right: 60px;
    color: rgba(58, 98, 215, 100);
    font-size: 14px;
    font-family: SourceHanSansSC-regular;
    cursor: pointer;
  }
  .submit-btn {
    width: 100%;
    background-color: rgba(58, 98, 215, 100);
    color: #fff;
  }
}
</style>
